import snackbarComponent from './snackbar.component';
import SnackbarService from './snackbar.service';

export default angular.module('imomo.snackbar', [])
    .component('imomoSnackbar', snackbarComponent)
    .service('snackbarService', SnackbarService)
    .name;



/** WEBPACK FOOTER **
 ** ./app/snackbar/snackbar.module.ts
 **/